import ButtonLink from "PFComponents/button/button_link";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const ChangeRequestAction = ({ user }) => {
  const { t } = useTranslation("admin", { keyPrefix: "users.list.actions" });

  return (
    <ButtonLink
      small
      kind="secondary"
      href={`/admin/change_requests/${user.id}`}
      qaId="AdminActionButton.change_requests"
    >
      {t("view")}
    </ButtonLink>
  );
};

ChangeRequestAction.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number
  })
};

export default ChangeRequestAction;
